// Dependencies
import clsx from 'clsx';
import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import TableCell from '@mui/material/TableCell';
// Actions
import { updateStocksClosedHoverDate, updateStocksClosedSale } from './redux/reducer';
// Types
import { Tooltip } from '@mui/material';
import { isNumber } from 'lodash';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../reducers';
import { BlackOutData } from './objects/blackOutData';

type ChannelManagerStockCalendarClosedSaleCellProps = {
    room_id: number;
    stock_index: number;
    stock: any; // TODO change type to real type
    black_outs: BlackOutData[];
};

const ChannelManagerStockCalendarClosedSaleCell: FC<
    ChannelManagerStockCalendarClosedSaleCellProps
> = ({ room_id, stock_index, stock, black_outs }): ReactElement | null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stocks_closed_sale_hover_date = useSelector((state: AppState) => state.channelManager.stocks_closed_sale_hover_date);
    const stocks_edit_mode = useSelector(
        (state: AppState) => state.channelManager.stocks_edit_mode
    );
    const stocks_state = useSelector((state: AppState) => state.channelManager.stocks_state);
    const stocks_closed_sale_start_date = useSelector(
        (state: AppState) =>
            state.channelManager.stocks_closed_sale_start_date
    );
    const stocks_closed_sale_room_id = useSelector(
        (state: AppState) =>
            state.channelManager.stocks_closed_sale_room_id
    );
    const onClosedSaleClick = () => {
        if (stocks_edit_mode === 'ROOM_BLACK_OUTS') {
            dispatch(updateStocksClosedSale({ room_id, date: stock.date }));
        }
    };
    const onHover = () => {
        if(stocks_closed_sale_start_date && stocks_closed_sale_room_id === room_id ){
            dispatch(updateStocksClosedHoverDate(stock.date));
        }
    };

    const onMouseLeave = () => {
        if(stocks_closed_sale_start_date && stocks_closed_sale_room_id === room_id){
            dispatch(updateStocksClosedHoverDate(null));
        }
    };
    let is_closed = false;
    black_outs.map((black_out) => {
        if ((black_out.start_date !== null && black_out.end_date !== null) || black_out.date) {
            if (
                (stock.date >=
                    new Date(black_out.start_date).setHours(0, 0, 0, 0) &&
                stock.date <= new Date(black_out.end_date).setHours(0, 0, 0, 0)) || ((new Date(black_out?.date || '').setHours(0, 0, 0, 0)) === stock.date)
            ) {
                is_closed = true;
            }
        }
    });
    return (
        <Tooltip title={ stocks_edit_mode === 'ROOM_BLACK_OUTS' ? stocks_closed_sale_start_date && stocks_closed_sale_room_id === room_id
            ? t('shared.validate-sales-closing-period')
            :  stocks_closed_sale_room_id !== room_id && isNumber(stocks_closed_sale_room_id )? t('shared.validate-sales-closing-period-other-room', { room: stocks_state?.rooms?.find(room => room.id === Number(stocks_closed_sale_room_id))?.name }): t('shared.start-closing-sales'): ''}>
            <TableCell
                className={clsx('ft-roomStockCell ft-roomStockCellName', {
                    ['ft-roomStockClosed']: is_closed,
                    ['ft-roomStockCellClicked']: stocks_closed_sale_start_date
                        ? stocks_closed_sale_start_date === stock.date &&
                      stocks_closed_sale_room_id === room_id
                        : false,
                    ['ft-roomStockCellHovered']: stocks_closed_sale_hover_date && stocks_closed_sale_start_date && stocks_closed_sale_room_id === room_id && ((stocks_closed_sale_hover_date >= stock.date && stocks_closed_sale_start_date < stock.date) || (stocks_closed_sale_hover_date <= stock.date && stocks_closed_sale_start_date > stock.date))
                })}
                onClick={onClosedSaleClick}
                onMouseOver={onHover}
                onMouseLeave={onMouseLeave}
            />
        </Tooltip>
    );
};

export default React.memo(ChannelManagerStockCalendarClosedSaleCell);
